import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip, Typography } from '@mui/material';

import { IRubricLevelModel } from '@common/models/Rubrics/RubricLevel';

interface StudentRubricProps {
	rubricLevel: IRubricLevelModel;
}

function StudentRubric({ rubricLevel }: StudentRubricProps) {
	return (
		<Box display="flex" gap="4px">
			<Typography variant="subtitle2" fontWeight={400}>
				{rubricLevel.title}
			</Typography>
			<Tooltip
				sx={{ flexShrink: 0 }}
				arrow
				title={
					<Box display="flex" flexDirection="column" gap="4px">
						<Typography variant="body2">Description: {rubricLevel.description}</Typography>
						<Box display="flex" gap="10px">
							<Typography variant="body2">From: {rubricLevel.percent_from}%</Typography>
							<Typography variant="body2">To: {rubricLevel.percent_to}%</Typography>
						</Box>
					</Box>
				}
			>
				<InfoOutlinedIcon fontSize="small" color="primary" />
			</Tooltip>
		</Box>
	);
}

export default StudentRubric;
